/* eslint-disable no-console */

export default function consoleAppender(logEvent) {
  const level = logEvent.level || 'INFO';

  switch (level) {
    case 'DEBUG':
      console.debug(logEvent.message, logEvent);
      break;

    case 'ERROR':
      console.error(logEvent.message, logEvent);
      break;

    case 'WARN':
      console.warn(logEvent.message, logEvent);
      break;

    default:
      console.log(logEvent.message, logEvent);
  }
}
